/** Editor API — link metadata + future editor-helper endpoints. */
import {createApi} from './_factory'
import type {EditorNs} from '@shared/types'

const api = createApi('editor')

export const EditorApi = {
  /** GET /editor/getLinkMeta?url=... Suppresses the global toaster on failure. */
  getLinkMeta: (url: string) =>
    api.get<EditorNs.GetLinkMetaResponse>(
      `getLinkMeta?url=${encodeURIComponent(url)}`,
      {showErrorOnToaster: false},
    ),
}
